import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { createQuizRequested } from 'features/quizzes/actions';

export function* createQuizSaga(action: ReturnType<typeof createQuizRequested>) {
  yield call(SignalingSocket.send, { event: 'createQuiz', data: action.payload });
}
